 (function (Wishlist, $) {
   
  var ActwishlistArr = localStorage.getItem('Accountwishlist') || [];
 var varient = localStorage.getItem('varient_product') || [];
  var $wishlistButton = $('.wishlist-btn');
  var $wishlistTile = $('.wishlist-tile-container');
  var $wishlistItemCount = $('.wishlist-item-count');
  var numProductTiles = $wishlistTile.length;

 
   //krunal start
  var variantwish = localStorage.getItem('user_variantwish') || [];

   var wishlist = localStorage.getItem('user_wishlist') || [];
  if (wishlist.length > 0) {
    wishlist = JSON.parse(localStorage.getItem('user_wishlist'));
  }
  if (variantwish.length > 0) {
    variantwish = JSON.parse(localStorage.getItem('user_variantwish'));    
  }
   
  /*
   * Update button to show current state (gold for active)
   */   
  var animateWishlist = function (self) {
    $(self).toggleClass('is-active');
  };
  
  var updateWishlist = function (self) {
    var url =(window.location.href);
    var varaintID = '';
    var Toadd = true;
  var productHandle = $(self).attr('data-product-handle');
    if($('#ProductSelect-product-template').val() != null){
     varaintID = $('#ProductSelect-product-template').val()
     } else{
         varaintID = url.split('?variant=').pop();
     }
      //check selected product has variants?
      if(varaintID)
      {
        // check if it is already in wishlist
           for (var i = 0; i < variantwish.length; i++) {
              if (variantwish[i]['varient_id'] == varaintID ) {    
                  Toadd= false ;  
                   break;
              }
           }
     
     if(Toadd)
        {  // insert variant in variant array 
            valueToPush  =  { };
                var count = 1; 
                var avail = $("#sold").text();
                var imageAttr = '';
          if($( '.swiper-container.gallery-top .swiper-wrapper .swiper-slide' ).not( ".hide" )){
            imageAttr = $( '.swiper-container.gallery-top .swiper-wrapper .swiper-slide' ).not( ".hide" ).children('div.product-img').children('img').attr('src');
          }
                var size =($("#SingleOptionSelector-1").val() ? $("#SingleOptionSelector-1").val() : "Default");
                var color = ($("#SingleOptionSelector-0").val() ? $("#SingleOptionSelector-0").val() : "Default");
                var product_id=$(".product-form-product-template").attr('id').split('_').pop();
                valueToPush["productHandle"]= productHandle;
                valueToPush["productID"] = product_id;
                valueToPush["varient_id"] = varaintID;
                valueToPush["size"] = size;
                valueToPush["color"] = color;
                valueToPush["avail"] = avail;
				valueToPush["imageAttr"] = imageAttr;
          
               // console.log(variantwish);
                for (var i = 0; i < variantwish.length; i++) {
                  if (variantwish[i]['productID'] == product_id) {

                   count++;

                   break;
                  } 
                }
                valueToPush["count"] = count;
                variantwish.push(valueToPush);
                localStorage.setItem('user_variantwish', JSON.stringify(variantwish));
                $('#wishlist-count').text(variantwish.length);                      

            }
      
      }
    

  // check in wishlist item exixst or not 
    // if not push in wishlist 
    if( wishlist.indexOf(productHandle) === -1)
      {
       
       wishlist.push(productHandle);
       localStorage.setItem('user_wishlist', JSON.stringify(wishlist));
      
      }
  
  };
  /*
   * Loop through wishlist buttons and activate any items that are already in user's wishlist
   * Activate by adding class 'is-active'
   * Run on initialization
   */   
  var activateItemsInWishlist = function () {
    $wishlistButton.each(function () {
      var productHandle = $(this).attr('data-product-handle');
      if (wishlist.indexOf(productHandle) > -1) {
        $(this).addClass('is-active');
        
      }
    });
  };

  /*
   * Loop through product titles and remove any that aren't a part of the wishlist
   * Decrement numProductTiles on removal
   */   
  var displayOnlyWishlistItems = function () {
    $wishlistTile.each(function () {
      var productHandle = $(this).attr('data-product-handle');
      if (wishlist.indexOf(productHandle) === -1) {
        $(this).remove();
        numProductTiles--;
      }
    });
    
  };
  /*
   * Check if on the wishlist page and hide any items that aren't a part of the wishlist
   * If no wishlist items exist, show the empty wishlist notice
   */   
  var loadWishlist = function () {
    if (window.location.href.indexOf('pages/wishlist') > -1) {
      displayOnlyWishlistItems();
      $('.wishlist-loader').fadeOut(1000, function () {
        $('.wishlist-grid').addClass('is_visible');
        $('.wishlist-hero').addClass('is_visible');
        $('.empty-list--btn').css('display','block');
        if (numProductTiles == 0) {
          $('.wishlist-grid--empty-list').addClass('is_visible');
        } else {
          $('.wishlist-grid--empty-list').hide();
        }
      });
    }
  };

  /**
   * Display number of items in the wishlist
   * Must set the $wishlistItemCount variable
   */
  var updateWishlistItemCount = function () {
    if (wishlist) {
      $wishlistItemCount.text(wishlist.length);
    }
  };
  var removeclass = function (){
     $(this).removeClass('is-active');
     
  };

  var bindUIActions = function () {
    $wishlistButton.click(function (e) {
      e.preventDefault();
      updateWishlist(this);
      animateWishlist(this);
      removeclass(this);
    });
  };
  Wishlist.init = function (id) {
    
    bindUIActions();
    activateItemsInWishlist();
    loadWishlist();
    updateWishlistItemCount();
  };
  
  Wishlist.getVarient = function(){
 variantwish = localStorage.getItem('user_variantwish')  ; 
  return varient;
  
  }
  Wishlist.previousPush = function(){
    var newVarient = true;
     var arrWishlist =JSON.parse(sessionStorage.getItem('Accountwishlist'+id));
      var arrVariant = JSON.parse(sessionStorage.getItem('AccountVariantlist'+id));
        console.log(arrVariant[0]['varient_id'] );
     // console.log(variantwish);
    //	console.log(variantwish.length);
    for (var i = 0; i < variantwish.length; i++) {
         for (var j = 0; j < arrVariant.length; j++) {
               
              if (variantwish[0]['varient_id'] == arrVariant[0]['varient_id'] ) {    
                 newVarient= false ;  
                   break;
              }
           }
      if(newVarient == true)
      { console.log(arrWishlist.indexOf(variantwish[i]['productHandle']));
        if(arrWishlist.indexOf(variantwish[i]['productHandle']) != -1)
          variantwish[i]['count'] = 2 ;
        arrVariant.push(variantwish[i]);
      }
    }
    wishlist.forEach(checkItem);   
      function checkItem(item, index, arr) {
        if((arrWishlist.indexOf(item) )== -1 )
         arrWishlist.push(item);
      } 
    localStorage.setItem("user_wishlist",JSON.stringify(arrWishlist));
   localStorage.setItem("user_variantwish",JSON.stringify(arrVariant));
   };
  // remove all item from wishlist on logout
  Wishlist.empty = function (id) {
    var arrWishlist = JSON.parse(localStorage.getItem('user_wishlist'));
    var  arrVariant = JSON.parse(localStorage.getItem('user_variantwish'));
    sessionStorage.setItem("Accountwishlist"+id,JSON.stringify(arrWishlist));
    sessionStorage.setItem("AccountVariantlist"+id,JSON.stringify(arrVariant));
    localStorage.removeItem('user_wishlist') ;
    localStorage.removeItem('user_variantwish');
    wishlist = [];
    variantwish  = [];
    valueToPush ={};
  };
   
    //update localstorage
//    $("#product-select , .color-box-list").change(function() { 
//      console.log(variantwish);
//       localStorage.setItem('user_wishlist', JSON.stringify(wishlist)); 
//       localStorage.setItem('user_variantwish', JSON.stringify(variantwish));
   
//    });
   
}(window.Wishlist = window.Wishlist || {}, jQuery, undefined));

 